import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const HelpCenter = () => <PublicStaticPage pageKey="help" />;

export default HelpCenter;
